import { Directive, Input } from '@angular/core';
import { PhxCellHighlightIntent, PhxTableCellAlign, PhxTableCellVerticalAlign } from '../phx-table.types';

@Directive()
export abstract class PhxCellBase {
  /** Horizontal text alignment override for this cell. */
  @Input() phxAlign: PhxTableCellAlign | undefined;
  /** When true, draws a colored left border highlight on the cell. */
  @Input() phxHighlightBorder: boolean = false;
  /** Selects the highlight border color when `phxHighlightBorder` is true. */
  @Input() phxHighlightIntent: PhxCellHighlightIntent | undefined;
  /** When true, shows a skeleton loading state inside the cell. */
  @Input() phxLoading: boolean = false;
  /** When true, draws a left border on the cell. */
  @Input() phxBorderLeft: boolean = false;
  /** When true, draws a right border on the cell. */
  @Input() phxBorderRight: boolean = false;
  /** Vertical alignment of cell content. Default `'top'`. */
  @Input() phxVerticalAlign: PhxTableCellVerticalAlign = 'top';
  /** Number of columns this cell spans. */
  @Input() phxColspan: number | undefined;
  /** Number of rows this cell spans. */
  @Input() phxRowspan: number | undefined;
}
